import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        paymentId: Number,
    };

    open() {
        $(this.element).modal('show');
    }

    refund() {
        showPreloader();

        $.get(routes['app_payments_refund'].replace('__id__', this.paymentIdValue), {}, result => {
            showPreloader();
            const $form = $(result);

            $('body').append($form);

            $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data: $form.serialize(),
                success: (result) => {
                    if (result.refunded) {
                        $('#payment-refund-success-modal').modal('show').on('hide.bs.modal', () => {
                            window.location.reload();
                        });
                    } else {
                        addAlert('danger', translations['profile.An unknown error occurred.']);
                    }

                    hidePreloader();
                },
                error: () => {
                    hidePreloader();
                    addAlert('danger', translations['profile.An unknown error occurred.']);
                },
            });
        }).always(() => {
            $(this.element).modal('hide');
        });
    }
}
